import * as React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../PDFStyle';
import { IProjectInfoForm } from '../../../pages/ProjectInfo/IProjectInfo';
import { useTranslation } from 'react-i18next';

interface IProjectInformationProps {
    projectInfo: IProjectInfoForm;
    width?: string;
}

const ProjectInformation = (props: IProjectInformationProps) => {
    const { t } = useTranslation();
    const { projectInfo, width } = props;
    return (
        <View style={{ width: width ?? '100%' }}>
            <Text style={styles.title}>{t('pdf_project_information')}</Text>
            <View style={styles.rowSpaceBetween}>
                <View style={styles.projectSection}>
                    <Text>
                        {t('pdf_title')}: {projectInfo!.name}
                    </Text>
                    <Text>
                        {t('pdf_number')}: {projectInfo!.number}
                    </Text>
                    <Text>
                        {t('pdf_header_client')}: {projectInfo!.client}
                    </Text>
                </View>
            </View>
        </View>
    );
};

export default ProjectInformation;
